import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-secondary-950 text-background-100 md:mt-24">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-lg font-black text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-200">
              {siteInfo.slogan}。把热门的独家吃瓜合集与独家吃瓜盘点，按主题整理成随时可以翻阅的目录。
            </p>
            <div className="mt-5 flex items-center gap-3 text-sm text-secondary-200">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900">
                <i className="ri-mail-line" />
              </span>
              <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-primary-300">
                {siteInfo.email}
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-200 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3 md:grid-cols-1">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?category=${cat.id}`}
                    className="text-sm text-secondary-200 transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50">订阅合集更新</h3>
            <p className="mt-3 text-sm leading-relaxed text-secondary-200">
              每周一封，只发整理好的独家吃瓜合集与新上线专题。
            </p>
            <div className="mt-4">
              <SubscribeForm tone="dark" />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteInfo.name} · 内容按公开讨论整理，仅供阅读参考
          </p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-300">
              关于我们
            </Link>
            <Link to="/rankings" className="transition-colors hover:text-primary-300">
              盘点榜单
            </Link>
            <span>自 {siteInfo.since} 年起整理</span>
          </p>
        </div>
      </div>
    </footer>
  );
}